const initialState = {
  logoutComplete: false
};

export default function(state = initialState, action){
    switch(action.type){
        case "DO_LOGOUT":
            return {
              ...state,
              logoutComplete: true
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/logout.js